/* eslint-disable no-console */
import { ResponseError } from '../api/notifications-api/index.js';

export const handleError = async (e: any, raiseDialog: boolean = true) => {
  let message = 'An error occurred';

  if (e instanceof ResponseError && e.response.status === 400) {
    try {
      const { detail } = await (e as ResponseError).response.json();
      message = detail;
      if (raiseDialog) console.error(message);
    } catch (e2: any) {
      console.error(e);
    }
  } else {
    console.error(e);
  }
};
